// 与 fz-android 的 GAMELAKA_EGYPT_AV 共用 Adjust 应用和事件。
// Adjust 后台需为该应用启用 Web 平台，H5 链接落地页保留对应 c 参数。
export default {
  appToken: "1z6zpyy2o1kw",
  registerToken: "k7mouw",
  purchaseToken: "l6e5v0",
  firstPurchaseToken: "ll6kib",
  // H5 独立链接识别码，保留 APK 的 22bq4guf。
  channels: {
    avh5: "244x4wf1",
    pp: "24m122y1",
  },
};
